import Text from 'components/Text/Text';
import React from 'react';
import CreatedField from './components/CreatedField';
import UpdatedField from './components/UpdatedField';
import style from './AdditionallyTab.module.scss';

const AdditionallyTab: React.FC = () => {
	return (
		<div className={style.container}>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="additionallyHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<CreatedField />
				<UpdatedField />
			</div>
		</div>
	);
};

export default AdditionallyTab;
